/**
 * Allows secure export of CSV https://owasp.org/www-community/attacks/CSV_Injection
 * @public
 */
export const csvExportParams = {
    processCellCallback: (params) => {
        if (['+', '=', '-', '@', '\t', '\n'].some((character) => String(params.value).startsWith(character))) {
            return `'${params.value}`;
        }
        return params.value;
    },
};
